import Cookies from "universal-cookie";
import { getFornecedoresAtivos } from "../../../../../../../../../controllers/fornecedores";

export async function loadFornecedores() {
    const cookies = new Cookies();
    const token = cookies.get("User-Token");
    const filters = { tipoFornecedor: "A" };

    const fornecedores = await getFornecedoresAtivos({ token, filters }).then((response) => {
        const body = JSON.parse(response.body);
        const r_fornecedores = body.map((fornecedor) => {
            return {
                id: fornecedor.iD_PESSOA,
                nome: fornecedor.nM_PESSOA,
            };
        });

        return r_fornecedores;
    });

    return fornecedores;
}
